import { Outlet, createRootRoute } from "@tanstack/react-router";

import { Providers } from "@/components/providers";
import { APP_NAME } from "@/lib/constants";

export const Route = createRootRoute({
  component: RootComponent,
  head: () => ({
    meta: [{ title: APP_NAME }],
  }),
});

function RootComponent() {
  return (
    <Providers>
      <Outlet />
    </Providers>
  );
}
